"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { fevicolInhomzRootRoute } from "../../../../_constants/tempRootRoute";
import { useDesignIdeaImagesStore } from "../../../_store/designIdeaImagesStore";
import DesignIdeaPageLayout from "./DesignIdeaPageLayout";

// Prefers the list the category grid already loaded (it can reach further
// than the server's first page); falls back to the server-fetched list on a
// direct visit/refresh. The clicked id becomes the hero, the rest "Similar ideas".
export default function DesignIdeaDetail(t0) {
  const $ = _c(35);
  const {
    category,
    title,
    imageId,
    hasTag,
    fallbackItems,
    contractors
  } = t0;
  let t1;
  if ($[0] !== category) {
    t1 = state => state.imagesByCategory[category];
    $[0] = category;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const stored = useDesignIdeaImagesStore(t1);
  let t2;
  if ($[2] !== fallbackItems || $[3] !== imageId || $[4] !== stored) {
    t2 = stored?.some(item => item.mediaGalleryId === imageId) ? stored : fallbackItems;
    $[2] = fallbackItems;
    $[3] = imageId;
    $[4] = stored;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const items = t2;
  let t3;
  if ($[6] !== imageId || $[7] !== items) {
    let t4;
    if ($[9] !== imageId) {
      t4 = item_0 => item_0.mediaGalleryId === imageId;
      $[9] = imageId;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = items.find(t4);
    $[6] = imageId;
    $[7] = items;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const hero = t3;
  let t4;
  if ($[11] !== imageId || $[12] !== items) {
    let t5;
    if ($[14] !== imageId) {
      t5 = item_1 => item_1.mediaGalleryId !== imageId;
      $[14] = imageId;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = items.filter(t5);
    $[11] = imageId;
    $[12] = items;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const similarItems = t4;
  if (!hero) {
    let t5;
    if ($[16] !== hasTag || $[17] !== title) {
      t5 = hasTag ? "This design idea could not be found." : `There are no designs for ${title.toLowerCase()} yet.`;
      $[16] = hasTag;
      $[17] = title;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    let t6;
    if ($[19] !== t5) {
      t6 = <p className="m3-body-large text-[--textSecondarySecondary]">{t5}</p>;
      $[19] = t5;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    const t7 = `${fevicolInhomzRootRoute}/design-ideas/${category}`;
    let t8;
    if ($[21] !== t7 || $[22] !== title) {
      t8 = <Link href={t7} className="m3-label-large text-[--colorPrimaryPrimary] underline">Back to {title}</Link>;
      $[21] = t7;
      $[22] = title;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    let t9;
    if ($[24] !== t6 || $[25] !== t8) {
      t9 = <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-4 text-center">{t6}{t8}</div>;
      $[24] = t6;
      $[25] = t8;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    return t9;
  }
  const t5 = hero?.mediaUrl;
  let t6;
  if ($[27] !== t5) {
    t6 = {
      src: t5
    };
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== category || $[30] !== contractors || $[31] !== similarItems || $[32] !== t6 || $[33] !== title) {
    t7 = <DesignIdeaPageLayout category={category} image={t6} title={title} similarItems={similarItems} contractors={contractors} />;
    $[29] = category;
    $[30] = contractors;
    $[31] = similarItems;
    $[32] = t6;
    $[33] = title;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  return t7;
}